import isMonetateGroup from '../app/utils/monetate/isMonetateGroup';

const fetchApi = async (url, options) => {
  try {
    const response = await window.fetch(url, options);
    return await response.json();
  } catch (err) {
    console.error(`Header: error fetching initial data from ${url}: ${err}`);
    return {};
  }
};

const getYesterday = () => {
  const date = new Date();
  date.setDate(date.getDate() - 1);
  return date.toISOString().slice(0, 10);
};

const fetchFallbackCategories = async features => {
  const isNavigationApi = isMonetateGroup(features, 'navigation-service');
  const api = isNavigationApi ? '' : '-categories';
  const cacheFilename = `/header-ui-assets/cache/fallback-cache${api}-${getYesterday()}.json`;
  const response = await fetchApi(cacheFilename);
  if (isNavigationApi) {
    return response;
  }
  return System.import(
    /* webpackChunkName: "transformer" */ '../server/fetch/categories/transformer'
  ).then(module => {
    const transformer = module.default;
    return transformer(response);
  });
};

const getInitialData = async () => {
  const stateUrl = '/header/api/state';
  const configUrl = '/header/api/config';

  const stateResponse = await fetchApi(stateUrl, {
    headers: { 'Cache-Control': 'no-cache' },
  });

  const configResponse = await fetchApi(
    `${configUrl}${stateResponse.headerClientConfigQueryParameters || ''}`
  );

  const categories =
    configResponse.categories ||
    (await fetchFallbackCategories(stateResponse.features));

  return {
    ...configResponse,
    ...stateResponse,
    categories,
  };
};

export default getInitialData;
